import {
  Box,
  Collapse,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  useContext,
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
} from 'react';
import Arrow1 from 'assets/images/Arrow1.png';
import { ReactComponent as Messageicon } from 'assets/svg/Message.svg';

import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom';
import './Message.css';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { datacontextsoli } from 'modules/private/BuyerSolicitor/BuyerSolicitor';
import InitiateSign from './InitiateSign';
import {
  APP_SCALE,
  MOXO_USER_ID,
  RCP_API_URL,
  USER_MAIL_ID,
} from 'constant/app.config';
import { init } from '@YaaryAi/moxo-web-fe';
import { createPortal } from 'react-dom';
import SiderComponent from 'component/sider';
import { poppins400 } from 'theme/common.style';

const Message = () => {
  const history = useHistory();
  const urlparam = useParams();
  const classes = useStyles();
  const theme = useTheme();
  const sdkRef = useRef(null);
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesxl = useMediaQuery(theme.breakpoints.up('xl'));
  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));
  const currentPage = window.location.pathname;

  /** HEADER OFFSET (same as dev) */
  const headerTop =
    primaryUserTypeValue === 'Agent'
      ? matchesxl
        ? 100
        : 80
      : matchesxl
      ? 55
      : 45;

  const contextValue =
    useContext(
      currentPage?.includes('/solicitor') ? datacontextsoli : datacontext
    ) || {};

  const {
    callwaiting,
    setCallwaiting,
    setShowMessage,
    messagedata,
    setMessagedata,
  } = contextValue;
  const { BuyerSolicitor, binderId, incomingcall, buyerid, proid } =
    messagedata || {};

  const [mounted, setMounted] = useState(false);
  const [openMoxo, setOpenMoxo] = useState(true);
  const [isClosingDown] = useState(false);
  const [scaledReady, setScaledReady] = useState(false);

  const moxoRef = useRef(null);
  const portalRootRef = useRef(null);

  const baseURL = RCP_API_URL;

  const authConfig = {
    orgId: 'Pd7iYEBgFzz1IzINAWois2I',
    uniqueId: USER_MAIL_ID, // User email or unique ID
    userId: MOXO_USER_ID,
    clientId: 'NDY2NGY2OWR',
    clientSecret: 'Y2Y1OTE4NDR',
    isAdmin: false, //top and side bar visiblity
  };

  /** Mount guard */
  useEffect(() => {
    portalRootRef.current = document.getElementById('overlay-root');
    setMounted(true);
  }, []);

  /** Init Moxo */
  useEffect(() => {
    if (!mounted) return;
    if (!portalRootRef.current) return;
    if (!moxoRef.current) return;

    const timer = setTimeout(() => {
      try {
        sdkRef.current = init('#moxo-web-sdk', {
          baseURL,
          auth: authConfig,
          // binderId: 'f5cefabc-15b1-41a4-b0be-284ffeac4d35', // Opens this chat automatically
          binderId, // Opens this chat automatically
        });
      } catch (e) {
        console.error('Moxo init failed:', e);
      }
    }, 50);

    return () => {
      clearTimeout(timer);

      // 🔥 DESTROY HERE
      if (sdkRef.current) {
        sdkRef.current.destroy();
        sdkRef.current = null;
      }
    };
  }, [mounted, binderId]);

  /** Prevent scaling flash */
  useLayoutEffect(() => {
    setScaledReady(true);
  }, []);

  const handleCloseMoxo = () => {
    if (sdkRef.current) {
      sdkRef.current.destroy();
      sdkRef.current = null;
    }
    setShowMessage(false);
    setOpenMoxo(false);
  };

  /** Portal safety */
  if (!mounted || !portalRootRef.current) return null;

  return createPortal(
    <Grid>
      <Collapse in={openMoxo}>
        <Grid
          container
          wrap="nowrap"
          // className={
          //   isClosingDown ? classes.slideOutBottom : classes.slideInRight
          // }
          sx={{
            position: 'fixed',
            top: `${headerTop}px`,
            left: 0,

            transform: `scale(${APP_SCALE})`,
            transformOrigin: 'top left',

            width: `${100 / APP_SCALE}%`,

            height: `calc((100vh - ${headerTop}px) / ${APP_SCALE})`,

            backgroundColor: '#ffffff',
            zIndex: 999999,
            visibility: scaledReady ? 'visible' : 'hidden',
            display: 'flex',
          }}
        >
          {/* SIDER */}
          {!matcheslg && !currentPage?.includes('/solicitor') && (
            <Grid
              item
              sx={{
                width: '106px',
                height: '100%',
                flexShrink: 0,
                borderRight: '1px solid #E0E0E0',
                backgroundColor: '#fff',
              }}
            >
              <SiderComponent ismessage={true} />
            </Grid>
          )}

          {/* SDK AREA */}
          <Grid
            item
            sx={{
              flexGrow: 1,
              height: '100%',
              display: 'flex',
              overflow: 'hidden',
              flexDirection: 'column',
            }}
          >
            {!currentPage.includes('/solicitor') && (
              <>
                <Grid className={classes.backtogrid}>
                  <img alt="arrow" src={Arrow1} />
                  <Typography
                    onClick={handleCloseMoxo}
                    className={classes.backto}
                  >
                    Back to Previous
                  </Typography>
                </Grid>
                <Grid className={classes.labelgrid}>
                  <Messageicon />
                  &nbsp;
                  <Grid className={classes.labeltext}>Messaging</Grid>
                </Grid>
              </>
            )}
            <Grid
              container
              className={classes.wholecontainer}
              sx={{
                height: '100%',
              }}
            >
              {urlparam?.buyerid && urlparam?.proid && (
                <Grid item className={classes.subcontainer1}>
                  <InitiateSign
                    buyerid={urlparam?.buyerid}
                    proid={urlparam?.proid}
                  />
                </Grid>
              )}
              <Grid
                item
                className={classes.subcontainer2}
                sx={{
                  flex: 1,
                  minHeight: 0,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  id="moxo-web-sdk"
                  ref={moxoRef}
                  sx={{
                    flexGrow: 1,
                    height: '100%',
                    width: '100%',
                    minHeight: 0,
                    borderTop:
                      !currentPage.includes('/solicitor') &&
                      '1px solid #8d8d8d !important',
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Collapse>
    </Grid>,
    portalRootRef.current
  );
};

const useStyles = makeStyles(() => ({
  backtogrid: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '20px',
    height: '8%',
  },
  labeltext: {
    fontFamily: 'poppins',
    fontSize: '32px',
    color: '#112347',
    fontWeight: 600,
  },
  backto: {
    color: '#6C2AD2',
    ...poppins400,
    fontSize: '16px',
    cursor: 'pointer',
    py: '15px',
  },
  labelgrid: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    height: '7%',
  },
  wholecontainer: {
    flex: 1,
    minHeight: 0,
  },

  subcontainer1: {
    width: '350px',
  },

  subcontainer2: {
    flexGrow: 1,
    height: '100%',
  },

  slideInRight: {
    animation: '$slideInRight 0.4s ease-out',
  },

  slideOutBottom: {
    animation: '$slideOutBottom 0.4s ease-out',
  },

  '@keyframes slideInRight': {
    from: { transform: 'translateX(100%)' },
    to: { transform: 'translateX(0)' },
  },

  '@keyframes slideOutBottom': {
    from: { transform: 'translateY(0)' },
    to: { transform: 'translateY(100%)' },
  },
  horizontalDivider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#8d8d8d',
    marginTop: '5px',
    marginBottom: '10px',
  },
}));

export default Message;
